module.exports = __webpack_public_path__ + "media/images/path-8c666ca480c987849f7a33fce8c6b833.svg";